import { render } from "./ExpressQuestion.vue?vue&type=template&id=0b9bda5d&scoped=true"
import script from "./ExpressQuestion.vue?vue&type=script&lang=js"
export * from "./ExpressQuestion.vue?vue&type=script&lang=js"

import "./ExpressQuestion.vue?vue&type=style&index=0&id=0b9bda5d&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b9bda5d"]])

export default __exports__